export default "__VITE_ASSET__C3sdz5RV__"